"use client";

import React from "react";
import { ProfileIcon } from "components/SVG";
import { loginWithRedirect } from "hooks/utils/loginWithRedirect";
import type { LocaleOfStoreType } from "@beautypie/core";
import { useHasMounted } from "utils/wrappers";
import { LinkWithIcon } from "../LinkWithIcon";

type Props = {
  locale: LocaleOfStoreType;
  className?: string;
};

export const LoginLink: React.FC<Props> = ({ locale, className }) => {
  const hasMounted = useHasMounted();
  return (
    <LinkWithIcon
      className={className}
      icon={<ProfileIcon />}
      title="Login"
      href={
        // @TODO: loginWithRedirect cannot be used on the server, so we need to check if the component has mounted before calling it
        // This is a temporary solution until we have a better way to handle this
        !hasMounted
          ? `${locale === "en-US" ? "/us" : ""}/login`
          : `${locale === "en-US" ? "/us" : ""}${loginWithRedirect()}`
      }
    />
  );
};
